import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

@Injectable({ providedIn: 'root' })
export class GtmService {
  push(event: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
}
